import React from "react";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import LoadingButton from "@mui/lab/LoadingButton";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Stack from "@mui/material/Stack";
import { ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

// external library
import "react-photo-view/dist/react-photo-view.css";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import DataTable from "@/components/dataTable";
import Layout from "@/components/layout";
import Title from "@/components/title";
import { OutingTableColumn } from "@/config/tableColumnConfig";

// Fetch
import { getAll } from "@/fetch/fetchOuting";
// Moment
import { useCurrentAction } from "@/hooks/user";
import moment from "moment";
import "moment/locale/zh-hk";

const OutingPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();
  // Navigate
  const navigate = useNavigate();

  // States
  const [dataTableLoading, setDataTableLoading] = React.useState(false);
  const [outingData, setOutingData] = React.useState([]);
  const [isLoading, setLoading] = React.useState(false);
  const [selectedDate, setSelectedDate] = React.useState(
    moment().format("YYYY-MM-DD"),
  );

  // Fetch
  const fetchAll = async () => {
    try {
      const { data } = await getAll(selectedDate);
      setOutingData(data);
    } catch (error) {
    } finally {
      setLoading(false);
      setDataTableLoading(false);
    }
  };
  const getRowId = (row) => {
    return row.id;
  };
  React.useEffect(() => {
    actions && fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actions]);

  return (
    <Layout header="OutingPage" open={open} setOpen={setOpen}>
      <Title title={`出勤紀錄`} history={() => navigate(-1)} />
      <StyledPaper page={"yes"}>
        <Box sx={{ m: 3, width: "100%" }}>
          <Stack direction={"row"} alignItems={"center"} spacing={2}>
            <Stack alignItems={"center"}>
              <FormControl fullWidth>
                <DateTimePicker
                  slotProps={{
                    popper: {
                      sx: {
                        ".MuiPaper-root": {
                          border: "1px solid blue",
                          borderRadius: "10px",
                        },
                      },
                    },
                  }}
                  inputFormat="MM/YYYY"
                  renderInput={(props) => (
                    <TextField
                      color="success"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderBottomRightRadius: 0,
                          borderBottomLeftRadius: 0,
                        },
                      }}
                      {...props}
                    />
                  )}
                  label="Month"
                  openTo="month"
                  views={["year", "month"]}
                  value={selectedDate}
                  onChange={(event) => {
                    setSelectedDate(moment(event._d).format("YYYY-MM-DD"));
                  }}
                />
              </FormControl>
              <LoadingButton
                sx={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
                fullWidth
                onClick={() => {
                  setDataTableLoading(true);
                  setLoading(true);
                  fetchAll();
                }}
                size="small"
                loading={isLoading}
                loadingIndicator="Loading…"
                variant="contained"
                color="success"
              >
                搜尋
              </LoadingButton>
            </Stack>
          </Stack>
        </Box>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            disableExportButton={false}
            getRowId={getRowId}
            rows={outingData}
            columns={OutingTableColumn}
            pageSize={100}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default OutingPage;
